import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=0a40e0c3&scoped=true"
import script from "./myMessage.vue?vue&type=script&lang=js"
export * from "./myMessage.vue?vue&type=script&lang=js"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=0a40e0c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40e0c3",
  null
  
)

export default component.exports